import type { CityConfig } from "../city-template/types";

export const lakewoodCoConfig: CityConfig = {
  city: "Lakewood",
  state: "Colorado",
  stateAbbr: "CO",
  slug: "lakewood-co",
  route: "/lakewood-co",
  title: "Emergency Passport Lakewood, CO — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Lakewood, CO — as fast as 24 hours. Fast passport renewal, same-day help, and child passport expediting for Jefferson County and west Denver metro travelers. A+ BBB rated, registered State Dept. courier.",
  h1: "Emergency & Expedited Passport Services in Lakewood, CO",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Lakewood and west Denver metro travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Lakewood%20Colorado%20cityscape%20at%20golden%20hour%20with%20Belmar%20shopping%20district%20and%20Green%20Mountain%20in%20the%20background%2C%20Jefferson%20County%20suburban%20landscape%20with%20Rocky%20Mountain%20foothills%2C%20warm%20sunset%20light%20over%20the%20Denver%20west%20suburbs%2C%20modern%20residential%20neighborhood%20with%20mountain%20views%2C%20professional%20cityscape%20photography%2C%20warm%20amber%20and%20golden%20tones%2C%20no%20visible%20text%20or%20people%2C%20cinematic%20wide%20angle%20view&width=1800&height=700&seq=lakewood-co-hero-001&orientation=landscape",
  heroImageAlt: "Lakewood Colorado with Green Mountain and Rocky Mountain foothills in the background",
  geoPosition: "39.7047;-105.0814",
  geoPlacename: "Lakewood, Colorado",
  lastModified: "2026-06-03",
  regionalAgency: {
    name: "Colorado Passport Agency",
    address: "7245 S Havana Street Suite B-600, Centennial, CO 80112",
    distance: "Approximately 20 miles east — about 30 minutes via I-70 or 6th Ave",
  },
  nearbyCitiesZips: [
    { name: "Belmar District", zips: "80226, 80228" },
    { name: "Estes Park Blvd", zips: "80214, 80215" },
    { name: "Green Mountain", zips: "80227, 80228" },
    { name: "Applewood", zips: "80215" },
    { name: "Morrison", zips: "80465" },
    { name: "Littleton", zips: "80120, 80123, 80127" },
    { name: "Englewood", zips: "80110, 80113" },
    { name: "Wheat Ridge", zips: "80033, 80034" },
    { name: "Edgewater", zips: "80214" },
    { name: "Jefferson Hills", zips: "80235" },
    { name: "Bear Creek", zips: "80227" },
    { name: "Union", zips: "80228" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Lakewood departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels to our processing center" },
  ],
  internalLinks: [
    { name: "Fast passport renewal in Denver", route: "/denver" },
    { name: "Emergency passport help in Boulder", route: "/boulder" },
    { name: "Urgent passport services in Colorado Springs", route: "/colorado-springs" },
    { name: "Same-day passport help in Littleton", route: "/lakewood-co" },
    { name: "Expedited passport services in Englewood", route: "/lakewood-co" },
    { name: "Passport courier services in Wheat Ridge", route: "/lakewood-co" },
    { name: "Rush passport help in Morrison", route: "/lakewood-co" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Lakewood remotely via secure courier. We do not have a walk-in office in Lakewood — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Lakewood and Jefferson County travelers.",
  fpcOfficeAddress: "370 17th St, Denver, CO 80202",
  fpcOfficeDistance: "Serving all of Lakewood, Jefferson County, and the west Denver metro",
  serviceAreaIntro: "Fast Passport Center provides emergency and fast passport renewal services throughout Lakewood and the west Denver metro. From the Belmar shopping district to the Green Mountain neighborhood, from Jefferson County foothills to the suburban grid — we help Lakewood travelers get their passports fast, often in 24–48 hours through our registered courier service.",
  nearbyCitiesIntro: "We serve all Lakewood neighborhoods and nearby communities including Littleton, Englewood, Wheat Ridge, Morrison, and Edgewater. If you are in Jefferson County or the west Denver metro, we have you covered.",
  howItWorksIntro: "Most Lakewood travelers complete everything online and ship documents overnight. No need to cross the metro to Aurora or wait for a passport agency appointment. Our emergency and expedited passport process is designed for Lakewood travelers who need fast, reliable results.",
  mistakesIntro: "Lakewood travelers heading to Europe, Mexico, or the Caribbean can't afford passport delays. Here are the most common mistakes we see in the west Denver metro.",
  testimonialsIntro: "Lakewood travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Lakewood? Here are the most common ones we hear from Jefferson County travelers.",
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates (CDPHE)", url: "https://cdphe.colorado.gov/vital-records", desc: "Colorado Department of Public Health & Environment for vital records statewide" },
    { label: "Marriage Licenses (Jefferson County Clerk)", url: "https://www.jeffco.us/374/Clerk-Recorder", desc: "Jefferson County Clerk & Recorder for Lakewood area" },
    { label: "Divorce Decrees (Jefferson County District Court)", url: "https://www.courts.state.co.us/Courts/District/Index.cfm?District_ID=1", desc: "Jefferson County District Court for divorce decree records" },
    { label: "VitalChek Online Ordering", url: "https://www.vitalchek.com/", desc: "Order Colorado vital records online via VitalChek" },
  ],
  statePageRoute: "/states/colorado",
  statePageName: "Colorado",
  dmvWebsite: "https://dmv.colorado.gov",
  dmvLabel: "Colorado DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns and budget fights",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Lakewood international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Nicole K.",
      location: "Belmar District, Lakewood",
      rating: 5,
      text: "Booked a last-minute Italy trip and my passport was expired. Fast Passport Center had a renewal back to me in 4 days. No drive across town to Aurora needed. Absolute lifesaver.",
      service: "Emergency Renewal",
    },
    {
      name: "Tom H.",
      location: "Green Mountain, Lakewood",
      rating: 5,
      text: "Needed a child passport for my son before our Mexico vacation. Fast Passport Center walked us through everything — both parents, the right forms — and had it done in 5 days.",
      service: "Child Passport",
    },
    {
      name: "Rachel A.",
      location: "Applewood, Lakewood",
      rating: 5,
      text: "Lost my passport before a conference in London. They guided me through the DS-64 replacement process and had it done in 48 hours. Incredible. Highly recommend.",
      service: "Lost Passport",
    },
    {
      name: "Chris M.",
      location: "Littleton, CO",
      rating: 5,
      text: "I travel internationally several times a year. Fast Passport Center has been my go-to for years — faster than the Regional Agency and far cheaper than FedEx passport resellers.",
      service: "Expedited Renewal",
    },
  ],
  facilities: [
    {
      id: "lkw-1",
      name: "Lakewood Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "10799 W. Alameda Ave",
      city: "Lakewood",
      state: "CO",
      zip: "80226",
      phone: "(303) 989-0485",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "0.5 miles from Belmar Shopping District",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Accepts walk-ins but appointments preferred. Photo services available on-site.",
      icon: "ri-mail-line",
    },
    {
      id: "lkw-2",
      name: "Lakewood Kipling Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "3475 S. Kipling Pkwy",
      city: "Lakewood",
      state: "CO",
      zip: "80227",
      phone: "(303) 988-4434",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "0.5 miles from Green Mountain Village",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Green Mountain area location. Appointment strongly recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "lkw-3",
      name: "Edgewater Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1550 Depew St",
      city: "Edgewater",
      state: "CO",
      zip: "80214",
      phone: "(303) 232-4540",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "0.3 miles from Edgewater Public Market",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for east Lakewood and Edgewater residents. Limited passport hours.",
      icon: "ri-mail-line",
    },
    {
      id: "lkw-4",
      name: "Littleton Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "5901 S. Zang St",
      city: "Littleton",
      state: "CO",
      zip: "80127",
      phone: "(303) 979-2240",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "2 miles from south Lakewood border",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Accepts walk-ins but appointments preferred. Call ahead to confirm.",
      icon: "ri-mail-line",
    },
    {
      id: "lkw-5",
      name: "Wheat Ridge Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "4200 Yarrow St",
      city: "Wheat Ridge",
      state: "CO",
      zip: "80033",
      phone: "(303) 422-3855",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "3 miles from north Lakewood",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for north Lakewood residents. Limited passport hours — call to confirm.",
      icon: "ri-mail-line",
    },
    {
      id: "lkw-6",
      name: "Jefferson County Clerk",
      type: "County Clerk Passport Acceptance",
      address: "100 Jefferson County Pkwy",
      city: "Golden",
      state: "CO",
      zip: "80419",
      phone: "(303) 271-8168",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "10 miles from central Lakewood",
      website: "https://www.jeffco.us/",
      websiteLabel: "Jefferson County Clerk",
      notes: "Major county facility with extended hours. Appointments recommended.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — drive to Aurora (20 mi)", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Lakewood photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Lakewood acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Lakewood applicants show up with incorrect checks and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Denver regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Lakewood families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Lakewood travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Lakewood." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Lakewood address — trackable every step of the way." },
  ],
  faqs: [
    {
      q: "How fast can I get an emergency passport in Lakewood?",
      a: "Fast Passport Center offers emergency passport processing in Lakewood in as little as 24–48 hours. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities. This is the fastest reliable option for Lakewood travelers with urgent international flights.",
    },
    {
      q: "Can I get a same-day passport in Lakewood?",
      a: "Same-day passports are not available in Lakewood. The closest regional passport agency is in Aurora (20 miles). For urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option available to Lakewood residents without making the drive.",
    },
    {
      q: "Where can I get a fast passport renewal in Lakewood?",
      a: "Fast Passport Center offers fast passport renewal in Lakewood with no office visit required. We serve all Lakewood neighborhoods including Belmar, Green Mountain, and Applewood. Simply complete your application online, ship your documents using our prepaid overnight label, and our couriers handle the rest.",
    },
    {
      q: "What is the fastest way to get an urgent passport in Lakewood?",
      a: "The fastest way to get an urgent passport in Lakewood is through Fast Passport Center's emergency courier service. Our registered couriers deliver your documents directly to State Department processing facilities, achieving 24–48 hour turnaround.",
    },
    {
      q: "What if I live in nearby Littleton, Englewood, or Wheat Ridge?",
      a: "We serve all of Jefferson County and surrounding communities including Littleton, Englewood, Wheat Ridge, Morrison, and Edgewater. Our overnight shipping labels work from any UPS location.",
    },
    {
      q: "Where are the closest passport acceptance facilities in Lakewood?",
      a: "Popular options include Lakewood Main Post Office (80226), Lakewood Kipling Post Office (80227), Edgewater Post Office (80214), and Jefferson County Clerk (80419). All require appointments.",
    },
    {
      q: "How much does expedited passport service cost in Lakewood?",
      a: "Government fees are fixed: $130 for a passport book (adult) plus a $60 expedite fee. Fast Passport Center's service fees vary by processing speed. Contact us for a personalized quote.",
    },
    {
      q: "Do you help with passport photos in Lakewood?",
      a: "We guide you on exact photo requirements. Many CVS, Walgreens, and FedEx locations in Lakewood offer passport photo services. We review your photos before submission.",
    },
    {
      q: "What documents do I need for a first-time passport in Lakewood?",
      a: "You'll need proof of citizenship (birth certificate or naturalization certificate), government-issued photo ID (driver's license or REAL ID), two passport photos, and payment. We provide a complete checklist.",
    },
    {
      q: "Can you help with a child's passport in Lakewood?",
      a: "Yes. Child passports require both parents (or notarized consent from the absent parent), the child's birth certificate, and both parents' IDs. We walk Lakewood families through the entire process.",
    },
    {
      q: "Do I need to drive to Denver to get an expedited passport from Lakewood?",
      a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight from Lakewood. Our couriers handle the in-person delivery to State Department facilities.",
    },
    {
      q: "Is Fast Passport Center cheaper than going to the passport agency?",
      a: "In most cases, yes. Our best price guarantee means we're typically 30–100% less expensive than FedEx, Staples, and other third-party resellers.",
    },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Belmar", address: "400 S. Teller St, Lakewood, CO 80226", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Lakewood", address: "7301 W. Colfax Ave, Lakewood, CO 80214", hours: "Mon–Sun: 7AM–11PM" },
    { name: "FedEx Office — Lakewood", address: "1601 S. Wadsworth Blvd, Lakewood, CO 80232", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
    { name: "UPS Store — Lakewood", address: "2285 S. Wadsworth Blvd, Lakewood, CO 80227", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM" },
    { name: "Walmart — Lakewood", address: "10400 W. Colfax Ave, Lakewood, CO 80215", hours: "Mon–Sun: 6AM–11PM" },
    { name: "Walgreens — Englewood", address: "3750 S. Broadway, Englewood, CO 80113", hours: "Mon–Sun: 7AM–11PM" },
    { name: "FedEx Office — Littleton", address: "5871 S. Wadsworth Blvd, Littleton, CO 80123", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
    { name: "Costco — Lakewood", address: "1000 S. Wadsworth Blvd, Lakewood, CO 80226", hours: "Mon–Fri: 10AM–8:30PM, Sat–Sun: 9:30AM–6PM" },
  ],
  dmvLocations: [
    {
      name: "DMV — Lakewood",
      address: "1881 Pierce St, Lakewood, CO 80214",
      hours: "Mon–Fri: 8AM–5PM",
      note: "REAL ID and driver's license renewals. Appointment required.",
      featured: true,
    },
    {
      name: "DMV — Littleton",
      address: "5765 S. Windermere St, Littleton, CO 80120",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves south Lakewood and Littleton. Online appointment booking.",
      featured: false,
    },
    {
      name: "DMV — Englewood",
      address: "4800 S. Logan St, Englewood, CO 80113",
      hours: "Mon–Fri: 8AM–5PM",
      note: "REAL ID processing. Walk-ins limited — book online first.",
      featured: false,
    },
    {
      name: "DMV — Wheat Ridge",
      address: "4455 Wadsworth Blvd, Wheat Ridge, CO 80033",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Full-service center for north Lakewood residents.",
      featured: true,
    },
  ],
  airports: [
    {
      code: "DEN",
      name: "Denver International Airport",
      distance: "35 miles from Lakewood via I-70",
      address: "8500 Peña Blvd, Denver, CO 80249",
      note: "The primary international airport for Lakewood travelers. Easy I-70 access heading east from Lakewood.",
      flightUrl: "https://www.flydenver.com/",
      flightLabel: "DEN Flight Info",
      featured: true,
    },
    {
      code: "COS",
      name: "Colorado Springs Airport",
      distance: "80 miles from Lakewood via I-25",
      address: "7770 Milton E. Proby Pkwy, Colorado Springs, CO 80916",
      note: "Regional airport alternative for southern Colorado connections.",
      flightUrl: "https://www.coloradosprings.gov/airport",
      flightLabel: "Colorado Springs Airport",
      featured: false,
    },
  ],
};